import React, { lazy, Suspense } from "react";
import {
  Route,
  Redirect,
  BrowserRouter as Router,
  Switch,
  useHistory,
} from "react-router-dom";
import { PUBLIC_ROUTE } from "./route.constants";
import Loader from "./components/utility/loader";
import Topbar from "./containers/Topbar/Topbar";
import Sidebar from "./containers/Sidebar/Sidebar";
import Footer from "./containers/Footer/Footer";
import Rightbar from "./containers/Rightbar/Rightbar";
import SettingsWrapper from "./containers/SettingsWrapper/SettingsWrapper";
import NotFound from "./containers/Pages/404/404";
import HomeDashboard from "./containers/Dashboard/HomeDashboard";
import ScrollToTop from "./components/ScrollToTop";
import { createBrowserHistory } from "history";
export const history = createBrowserHistory();

const Dashboard = lazy(() => import("./containers/Dashboard/Dashboard"));

const publicRoutes = [
  {
    path: PUBLIC_ROUTE.LANDING,
    exact: true,
    component: lazy(() => import("./containers/Pages/SignIn/SignIn")),
  },
  {
    path: PUBLIC_ROUTE.SIGN_IN,
    exact: true,
    component: lazy(() => import("./containers/Pages/SignIn/SignIn")),
  },
  {
    path: PUBLIC_ROUTE.EMAIL_VERIFICATION_ARABIC,
    exact: false,
    component: lazy(() =>
      import("./containers/Pages/EmailVerificationWeb/EmailVerification-ar")
    ),
  },
  {
    path: PUBLIC_ROUTE.EMAIL_VERIFICATION_ENGLISH,
    exact: false,
    component: lazy(() =>
      import("./containers/Pages/EmailVerificationWeb/EmailVerification-en")
    ),
  },
  {
    path: PUBLIC_ROUTE.EMAIL_VERIFICATION_ENGLISH,
    exact: false,
    component: lazy(() =>
      import("./containers/Pages/EmailVerificationWeb/EmailVerification-en")
    ),
  },
  {
    path: PUBLIC_ROUTE.VERIFY_EMAIL_ENGLISH,
    exact: false,
    component: lazy(() =>
      import("./containers/Pages/VerifyEmailTemplate/VerifyEmail")
    ),
  },
  {
    path: PUBLIC_ROUTE.VERIFY_EMAIL_ARABIC,
    exact: false,
    component: lazy(() =>
      import("./containers/Pages/VerifyEmailTemplate/VerifyEmail-ar")
    ),
  },
  {
    path: PUBLIC_ROUTE.RESET_CODE,
    component: lazy(() =>
      import("./containers/Pages/ForgotPassword/ResetCode")
    ),
  },
  {
    path: PUBLIC_ROUTE.RESET_PASSWORD,
    component: lazy(() =>
      import("./containers/Pages/ForgotPassword/ResetPassword")
    ),
  },
  {
    path: PUBLIC_ROUTE.FORGOT_PASSWORD,
    component: lazy(() =>
      import("./containers/Pages/ForgotPassword/ForgotPassword")
    ),
  },
];

function PrivateRoute({ children, ...rest }) {
  const isLoggedIn = localStorage.getItem("pillvery_token") ? true : false;
  return (
    <>
      <Route
        {...rest}
        render={({ location }) =>
          isLoggedIn ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: "/signin",
                state: { from: location },
              }}
            />
          )
        }
      />
    </>
  );
}

export default function Routes() {
  return (
    <Suspense fallback={<Loader />}>
      <Router history={history}>
        <ScrollToTop />
        <Switch>
          {publicRoutes.map((route, index) => (
            <Route key={index} path={route.path} exact={route.exact}>
              <route.component />
            </Route>
          ))}

          <PrivateRoute path="/dashboard">
            <Dashboard />
          </PrivateRoute>
        </Switch>
      </Router>
    </Suspense>
  );
}
